import {AxiosError} from 'axios';
import {GET_USER_GROUP_AUTHORITIES_URL} from 'web-library/constants/apiUrls';
import {GET_USER_GROUP_AUTHORITIES_QUERY_KEY} from 'web-library/constants/queryKeys';
import {
  UserGroupAccessConfigurationResponse
} from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

interface Input {
  uuid: string;
  onSuccess?: (res: UserGroupAccessConfigurationResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetUserGroupAuthorities = ({uuid, onError, onSuccess}: Input) => {
  const getUserGroupAuthorities = async () => {
    const res = await axiosClient.get<UserGroupAccessConfigurationResponse>(
        GET_USER_GROUP_AUTHORITIES_URL(uuid)
    );

    return res.data;
  };

  return useCustomQuery([GET_USER_GROUP_AUTHORITIES_QUERY_KEY, uuid], getUserGroupAuthorities, {
    onSuccess,
    onError,
  });
};
